import { connect } from "react-redux";
import { Link } from "react-router-dom";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var StudentAvatar = require("components/avatars/StudentAvatar");

require("users/students/student_display.scss")

@connect(
	(state, props) => {
		var downProps = {}
		downProps.student = RosterSelectors.student({ state, id: props.studentID })
		if (downProps.student && downProps.student.student_list_ids) {
			downProps.studentList = RosterSelectors.studentList({ state, id: downProps.student.student_list_ids.primary })
		}
		return downProps
	},
	(dispatch, props) => ({})
)
class StudentListDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var student = this.props.student;
		var studentList = this.props.studentList;
		if (studentList) {
			if (student.demo_for_teacher) {
				var studentListName = "(Demo Class)";
			} else {
				var studentListName = studentList.name;
			}
		} else {
			var studentListName = "--"
		}
		return (
			<div>
				<span className="studentListName">{ studentListName }</span>
			</div>
		);
	}
}

StudentListDisplay.WrappedComponent.propTypes = StrictPropTypes({
	// ID of the student to be displayed
	studentID: PropTypes.number.isRequired,

	// From @connect
	student: PropTypes.object,
	studentList: PropTypes.object,
	primaryStudentList: PropTypes.object

});

module.exports = StudentListDisplay


// WEBPACK FOOTER //
// ./modules/components/org/student_lists/StudentListDisplay.js